function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/**
 * Multiply years by this number to get the number of months
 */
var MonthsPerYear = 12;
/**
 * Divide by this number to convert a yearly rate in percent to
 * a monthly decimal rate
 */

var MonthlyRateDecimal = MonthsPerYear * 100;

/**
 * Note: Primarily for internal use, consider calculateMonthlyPayment
 * A Monthly Payment / Monthly dividend calculation for compounding interest
 * @param rate The Rate of the mortgage expressed as a monthly fraction.
 * @param payments The number of payments (usually years * 12)
 * @param presentValue The initial value of the mortgage
 * @param futureValue The targeted future value
 * @returns The monthly payment / dividend that must be paid to reach the target future
 * value given interest payments on the present value at the supplied rate.
 */
function PMT(rate, payments, presentValue, futureValue) {
  var rExp = Math.pow(1 + rate, payments);
  return rate * (futureValue + presentValue * rExp) / (rExp - 1);
}
/**
 * Note: primarily for internal use.
 * A Future value calculator.
 * @param rate The Rate of the mortgage expressed as a monthly fraction
 * @param pmt The amount of money to be paid every month.
 * @param pv The initial value of the loan to compute future value from.
 * @param nper The number of payments to make on the loan.
 * @returns The future value of the loan based on the accumulation of interest and the payments towards the principal and interest.
 */

function FV(rate, pmt, pv, nper) {
  var pow = Math.pow(1 + rate, nper);

  if (rate) {
    return pmt * (1 - pow) / rate + pv * pow;
  }

  return pv - pmt * nper;
}

/**
 * Given minimal loan inputs returns the monthly payment to pay principal and interest (P&I)
 * @returns The monthly payment that is required to pay this loan off over it's term.
 */
function computeMonthlyPayment(_ref) {
  var initialRate = _ref.initialRate,
      presentValue = _ref.presentValue,
      loanTerm = _ref.loanTerm;
  return PMT(initialRate / MonthlyRateDecimal, loanTerm * MonthsPerYear, presentValue, 0);
}
function createPAndICostModel(_ref2) {
  var initialRate = _ref2.initialRate,
      loanTerm = _ref2.loanTerm;
  var rate = initialRate / MonthlyRateDecimal;
  var rExp = Math.pow(1 + rate, loanTerm * MonthsPerYear);
  return [{
    presentValueFactor: rate * rExp / (rExp - 1),
    // Compounding Interest factor
    costOffset: 0,
    minPresentValue: Number.NEGATIVE_INFINITY,
    maxPresentValue: Number.POSITIVE_INFINITY
  }];
}

/**
 * A Cost model for monthly costs
 */

/**
 * A collection of labeled cost models.
 */

/**
 * Given a collection of cost models returns an array with
 * all the possible combinations of cost model permutations.
 * @param costs A collection of cost models
 * @returns a flattened list of combined cost models.
 */
function combineCostModels(costs) {
  var results = [];

  var _loop = function _loop() {
    var models = _Object$values[_i];

    if (models.length < 1) {
      return "continue";
    }

    if (results.length < 1) {
      results = models;
      return "continue";
    }

    results = results.flatMap(function (baseModel) {
      return models.map(function (_ref) {
        var presentValueFactor = _ref.presentValueFactor,
            costOffset = _ref.costOffset,
            minPresentValue = _ref.minPresentValue,
            maxPresentValue = _ref.maxPresentValue;
        return {
          presentValueFactor: baseModel.presentValueFactor + presentValueFactor,
          costOffset: baseModel.costOffset + costOffset,
          minPresentValue: Math.max(baseModel.minPresentValue, minPresentValue),
          maxPresentValue: Math.min(baseModel.maxPresentValue, maxPresentValue)
        };
      }).filter(function (_ref2) {
        var minPresentValue = _ref2.minPresentValue,
            maxPresentValue = _ref2.maxPresentValue;
        return minPresentValue <= maxPresentValue;
      });
    });
  };

  for (var _i = 0, _Object$values = Object.values(costs); _i < _Object$values.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return results;
}
/**
 * Given a set of cost models for specific labels
 * And given
 */

/**
 *
 * @returns
 */
function computeCostModels(_ref3) {
  var costs = _ref3.costs,
      presentValue = _ref3.presentValue;
  return Object.fromEntries(Object.entries(costs).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        models = _ref5[1];

    return [key, models.filter(function (_ref6) {
      var minPresentValue = _ref6.minPresentValue,
          maxPresentValue = _ref6.maxPresentValue;
      return presentValue >= minPresentValue && presentValue <= maxPresentValue;
    }).map(function (_ref7) {
      var costOffset = _ref7.costOffset,
          presentValueFactor = _ref7.presentValueFactor;
      return costOffset + presentValue * presentValueFactor;
    }).reduce(function (l, r) {
      if (Number.isNaN(l)) {
        return r;
      }

      if (Number.isNaN(r)) {
        return l;
      }

      return Math.min(l, r);
    }, Number.NaN)];
  }));
}

function computeMaxPresentValue(_ref) {
  var costs = _ref.costs,
      targetMonthlyPayment = _ref.targetMonthlyPayment;
  return combineCostModels(costs).map(function (_ref2) {
    var presentValueFactor = _ref2.presentValueFactor,
        costOffset = _ref2.costOffset,
        maxPresentValue = _ref2.maxPresentValue,
        minPresentValue = _ref2.minPresentValue;
    var computed = Math.min((targetMonthlyPayment - costOffset) / presentValueFactor, maxPresentValue);

    if (computed < minPresentValue) {
      computed = NaN;
    }

    return computed;
  }).reduce(function (l, r) {
    if (Number.isNaN(l)) {
      return r;
    }

    if (Number.isNaN(r)) {
      return l;
    }

    return Math.max(l, r);
  }, NaN);
}
/**
 * Inputs to the computeAffordability function
 */

/**
 * Given the affordability compute inputs returns the best affordability
 * @returns An affordability object with the max affordable Present Value and all the associated monthly costs.
 */
function computeAffordability(input) {
  var pAndI = createPAndICostModel(input);

  var costs = _objectSpread2(_objectSpread2({}, input.costs), {}, {
    pAndI: pAndI
  });

  var presentValue = computeMaxPresentValue(_objectSpread2(_objectSpread2({}, input), {}, {
    costs: costs
  }));
  return {
    presentValue: presentValue,
    costs: computeCostModels({
      presentValue: presentValue,
      costs: costs
    })
  };
}

var nearest8th = function nearest8th(rate) {
  var eights = rate * 8;
  var rounded = Math.round(eights);
  var r = rounded / 8;
  return r;
};

/**
 * Computes a monthly amortization schedule
 * for a given loan. An amortization schedule
 * shows the amount of principal and interest
 * that is payed every month and what the resulting
 * balance of the loan is.
 */
function computeAmortizationSchedule(_ref) {
  var initialRate = _ref.initialRate,
      presentValue = _ref.presentValue,
      _ref$fullyIndexedRate = _ref.fullyIndexedRate,
      fullyIndexedRate = _ref$fullyIndexedRate === void 0 ? initialRate : _ref$fullyIndexedRate,
      loanTerm = _ref.loanTerm,
      _ref$fixedTerm = _ref.fixedTerm,
      fixedTerm = _ref$fixedTerm === void 0 ? loanTerm : _ref$fixedTerm,
      _ref$adjustmentPeriod = _ref.adjustmentPeriod,
      adjustmentPeriod = _ref$adjustmentPeriod === void 0 ? 1 : _ref$adjustmentPeriod,
      _ref$caps = _ref.caps,
      caps = _ref$caps === void 0 ? {
    initial: 0,
    periodic: 0,
    lifetime: 0
  } : _ref$caps;
  var monthlyIndexedRate = nearest8th(fullyIndexedRate) / MonthlyRateDecimal;
  var maxRate = Math.min((initialRate + caps.lifetime) / MonthlyRateDecimal, monthlyIndexedRate);
  var minRate = Math.max((initialRate - caps.lifetime) / MonthlyRateDecimal, monthlyIndexedRate);
  var paymentPeriods = loanTerm * MonthsPerYear;
  var fixedPeriods = fixedTerm * MonthsPerYear;
  var periodsPerAdjustment = adjustmentPeriod * MonthsPerYear;
  var remainingBalance = presentValue;
  var monthlyDecimalRate = initialRate / MonthlyRateDecimal;
  var monthlyPayment = PMT(monthlyDecimalRate, paymentPeriods, remainingBalance, 0);
  var schedule = []; // iterate over the life of the loan, month by month

  for (var i = 0; i < paymentPeriods; i++) {
    // if we're beyond the fixed term
    if (i >= fixedPeriods) {
      // if we're at an adjustment
      if ((i - fixedPeriods) % periodsPerAdjustment === 0) {
        var cap = (i === fixedPeriods ? caps.initial : caps.periodic) / MonthlyRateDecimal;
        monthlyDecimalRate = Math.max(minRate, Math.min(monthlyDecimalRate + cap * (monthlyDecimalRate < monthlyIndexedRate ? 1 : -1), maxRate));
        monthlyPayment = PMT(monthlyDecimalRate, paymentPeriods - i, remainingBalance, 0);
      }
    }

    var interest = monthlyDecimalRate * remainingBalance;
    var paid = Math.min(remainingBalance + interest, monthlyPayment);
    remainingBalance = Math.max(remainingBalance - (paid - interest), 0);
    schedule.push({
      principal: paid - interest,
      interest: interest,
      balanceAtEndOfMonth: remainingBalance
    });
  }

  return schedule;
}

/**
 * Enhances an amortization schedule with PMI payments
 */
function computePMI(inputs, amortization) {
  return amortization.map(function (amortizationPeriod) {
    // only include pmi if the starting balance is more than 78% of the loan
    // lenders are required to remove the pmi after you have 22% equity.
    return _objectSpread2(_objectSpread2({}, amortizationPeriod), {}, {
      mortgageInsurance: (amortizationPeriod.balanceAtEndOfMonth + amortizationPeriod.principal) / inputs.propertyValue > 0.78 ? inputs.mortgageInsurance : 0
    });
  });
}
/**
 * Enhances an amortization schedule with FHA MIP payments
 */

function computeFHAMIP(inputs, amortization) {
  var loanValue = amortization[0].balanceAtEndOfMonth + amortization[0].principal - (inputs.upFrontMip || 0);
  return loanValue / inputs.propertyValue > 0.9 ? amortization.map(function (period) {
    return _objectSpread2(_objectSpread2({}, period), {}, {
      // more than 90% LTV you pay the mortgage insurance
      // every month
      mortgageInsurance: inputs.mortgageInsurance
    });
  }) : amortization.map(function (period, index) {
    return _objectSpread2(_objectSpread2({}, period), {}, {
      // Must pay mortgage insurance for 11 years.
      mortgageInsurance: index + 1 > MonthsPerYear * 11 ? 0 : inputs.mortgageInsurance
    });
  });
}

// can be problematic due to floating point percision errors.
// instead see if the numbers are very close.

var kindaEqual = function kindaEqual(numOne, numTwo) {
  return Math.abs(numOne - numTwo) < 0.000001;
};

/**
 * Compute the APR for a loan.
 *
 * APR attempts to account for the true cost of getting a mortgage by factoring the future value
 * of the up-front costs and other costs like mortgage insurance.
 * @param computeMI a function for applying mortgage insurance to an amortization table.
 * @returns the APR for the mortgage.
 */
function computeApr(inputs) {
  var computeMI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : computePMI;
  // Amoritzation Schedule for Fees over the life of the loan.
  // ie. What we would pay if we financed our fees. Which relates to
  // the lifetime value of fees assuming you'd invested them with the same
  // interest rate.
  var feeAmortization = computeAmortizationSchedule(_objectSpread2(_objectSpread2({}, inputs), {}, {
    presentValue: inputs.totalFees
  })); // Amortization Schedule for the loan. We need the full schedule for
  // we don't technically need the full schedule but it's useful to compute
  // it and then reduce to the data we need.

  var loanAmortization = computeAmortizationSchedule(inputs);
  var paymentGroups = computeMI(inputs, loanAmortization).map( // Include the mortgage insurance + feeAllocation + principal + interest in
  // the monthly payment
  function (_ref, i) {
    var principal = _ref.principal,
        interest = _ref.interest,
        mortgageInsurance = _ref.mortgageInsurance;
    var feeAllocation = i < feeAmortization.length ? feeAmortization[i].principal + feeAmortization[i].interest : 0;
    return principal + interest + feeAllocation + mortgageInsurance;
  }).reduce(function (grouped, monthlyPayment) {
    // group adjacent monthly payments by their value so end result will be
    //  something like [{monthlyPayment: 969, payments: 84},....]
    var lastIndex = grouped.length - 1;

    if (lastIndex >= 0 && kindaEqual(grouped[lastIndex].monthlyPayment, monthlyPayment)) {
      grouped[lastIndex].payments++;
    } else {
      grouped.push({
        monthlyPayment: monthlyPayment,
        payments: 1
      });
    }

    return grouped;
  }, []); // binary search for the apr
  // start with the loan rate, and work our way towards the actual apr.

  var rate = inputs.initialRate / MonthlyRateDecimal;
  var diff = rate;

  for (var t = 0; t < 100; t++) {
    // start with a present value of the loanValue
    var presentValue = inputs.presentValue;

    var _iterator = _createForOfIteratorHelper(paymentGroups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
            monthlyPayment = _step$value.monthlyPayment,
            payments = _step$value.payments;
        // repeated pay down the loan at the known monthlyPayment for
        // the known number of payments, at the estimated rate
        // for instance assume we have a 30 fixed rate loan with a single
        // payment group:
        // {monthlyPayment: 1050, payments: 360}
        // Given the value of the loan we can make 360 payments of 1050 at the
        //  rate of the apr and reach a future value of 0.
        presentValue = FV(rate, monthlyPayment, presentValue, payments);
      } // if the estimated rate produced a result of 0 than success!

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (kindaEqual(presentValue, 0)) {
      break;
    } // adjust rate and diff accordingly.


    rate += diff * (presentValue < 0 ? 1 : -1);
    diff /= 2;
  } // yearly rate as a percent, rather than monthly as a decimal.


  return rate * MonthlyRateDecimal;
}

/**
 * Correctly formats a dollar value to a string.
 * @param value The dollar value to format
 * @param returnNegative If false will use the absolute value of all values. True by default
 * @param fractionDigits  The number of digits to include. 0 by default.
 * @returns a string formatted dollar value.
 */
var formatCurrency = function formatCurrency(value) {
  var returnNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var fractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(returnNegative ? value : Math.abs(value));
};

/*
  calculate the total non-equity costs of a mortgage over its lifespan
*/

/**
 * Calculate the total non-equity costs of a mortgage over it's lifespan
 *
 * When paying a mortgage over time payments made to fees, interest, and mortgage insurance are effectively "lost" while
 * any money that is paid towards the principal or mortgage balance become equity in the home.
 * @param inputs inputs representing the loan
 * @param computeMI the function used to compute mortgage insurance, defaults to computeRegularMI
 * @returns the total dollar value of all fees, mortgage insurance, and interest paid over the life of the loan.
 */
function computeTotalCost(inputs) {
  var computeMI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : computePMI;
  return computeMI(inputs, computeAmortizationSchedule(inputs)).map(function (amorizationPeriod) {
    return amorizationPeriod.interest + amorizationPeriod.mortgageInsurance;
  }).reduce(function (prev, curr) {
    return prev + curr;
  }, inputs.totalFees);
}

var _excluded = ["computeMI"],
    _excluded2 = ["computeMI"];

var computeEquity = function computeEquity(amorizationPeriodsWithMI, _ref) {
  var totalFees = _ref.totalFees,
      propertyValue = _ref.propertyValue,
      presentValue = _ref.presentValue;
  // running total of costs accrued
  var costs = totalFees; // for each month of the loan total costs to that point less the equity in the property

  var equityLessCosts = [propertyValue - presentValue - costs];

  var _iterator = _createForOfIteratorHelper(amorizationPeriodsWithMI),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          interest = _step$value.interest,
          mortgageInsurance = _step$value.mortgageInsurance,
          balanceAtEndOfMonth = _step$value.balanceAtEndOfMonth;
      costs += interest + mortgageInsurance;
      equityLessCosts.push(propertyValue - balanceAtEndOfMonth - costs);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return equityLessCosts;
};

var compareArray = function compareArray(aArray, bArray) {
  var comparedArray = [];
  var aArrayMaxIndex = aArray.length - 1;
  var bArrayMaxIndex = bArray.length - 1;

  for (var idx = 0; idx <= aArrayMaxIndex || idx <= bArrayMaxIndex; idx++) {
    var a = aArrayMaxIndex >= idx ? aArray[idx] : aArray[aArrayMaxIndex];
    var b = bArrayMaxIndex >= idx ? bArray[idx] : bArray[bArrayMaxIndex];
    comparedArray.push(a === b ? 0 : a > b ? -1 : 1);
  }

  return comparedArray;
};
/**
  BreakEven, the amount of months until one loan becomes more expensive than another
 * @param inputA An input object representing one of the loans
 * @param inputB An input object representing one of the loans
 * @returns a positive integer, n if inputA is more expensive until n months out
 * @returns a POSITIVE_INFINITY if inputA is always more expensive,
 * @returns a negative integer, n if inputA is cheaper until n months out.
 * @returns a NEGATIVE_INFINITY if inputA is always cheaper
 * @returns 0 if inputA and inputB are always the same cost.
 */


function computeBreakEven(_ref2, _ref3) {
  var _ref2$computeMI = _ref2.computeMI,
      computeMIA = _ref2$computeMI === void 0 ? computePMI : _ref2$computeMI,
      a = _objectWithoutProperties(_ref2, _excluded);

  var _ref3$computeMI = _ref3.computeMI,
      computeMIB = _ref3$computeMI === void 0 ? computePMI : _ref3$computeMI,
      b = _objectWithoutProperties(_ref3, _excluded2);

  var _compareArray = compareArray(computeEquity(computeMIA(a, computeAmortizationSchedule(a)), a), computeEquity(computeMIB(b, computeAmortizationSchedule(b)), b)),
      _compareArray2 = _toArray(_compareArray),
      initialCompare = _compareArray2[0],
      compared = _compareArray2.slice(1);

  var minMonth = 1; // initially the same cost

  if (initialCompare === 0) {
    // find the index to strip off leading zeros
    var leadingZeros = compared.findIndex(function (v) {
      return v !== 0;
    }); // everything is zero

    if (leadingZeros === -1) {
      return 0;
    }

    minMonth += leadingZeros; // update the initial set and the comparison

    initialCompare = compared[leadingZeros];
    compared = compared.splice(0, leadingZeros + 1);
  } // find the point at which the comparison changes.


  var breakEvenPoint = compared.findIndex(function (compareResults) {
    return compareResults === initialCompare * -1;
  }); // no changes

  if (breakEvenPoint === -1) {
    return Number.POSITIVE_INFINITY * initialCompare;
  } else {
    // if a is initially more expensive (initialCompare === 1) return a positive number
    // if b is initially more expensive (initialCompare === -1) return a negative number
    return initialCompare * (breakEvenPoint + minMonth);
  }
}

export { FV, PMT, combineCostModels, computeAffordability, computeAmortizationSchedule, computeApr, computeBreakEven, computeCostModels, computeFHAMIP, computeMaxPresentValue, computeMonthlyPayment, computePMI, computeTotalCost, createPAndICostModel, formatCurrency };
//# sourceMappingURL=index.mjs.map
